// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import {
  DoNotDisturbAltOutlined,
  InventoryOutlined,
  KeyboardTabOutlined,
  ListRounded,
  LocalShippingOutlined,
  PendingOutlined,
} from '@/constants/hardfin-standard-icons';
import { ShipmentStatus } from '@/shipment/api/types';

export type ShipmentStatusFilter = ShipmentStatus | 'all';

const COMMON_STATUS_OPTIONS: FilterOption<ShipmentStatusFilter>[] = [
  { value: 'all', label: 'All', icon: <ListRounded fontSize="small" /> },
  {
    value: 'open',
    label: 'Open',
    icon: <PendingOutlined fontSize="small" />,
  },
  {
    value: 'shipped',
    label: 'Shipped',
    icon: <LocalShippingOutlined fontSize="small" />,
  },
  {
    value: 'delivered',
    label: 'Delivered',
    icon: <KeyboardTabOutlined fontSize="small" />,
  },
];

export const INBOUND_STATUS_OPTIONS: FilterOption<ShipmentStatusFilter>[] = [
  ...COMMON_STATUS_OPTIONS,
  {
    value: 'received',
    label: 'Received',
    icon: <InventoryOutlined fontSize="small" />,
  },
  {
    value: 'cancelled',
    label: 'Cancelled',
    icon: <DoNotDisturbAltOutlined fontSize="small" />,
  },
];

export const OUTBOUND_STATUS_OPTIONS: FilterOption<ShipmentStatusFilter>[] = [
  ...COMMON_STATUS_OPTIONS,
  {
    value: 'cancelled',
    label: 'Cancelled',
    icon: <DoNotDisturbAltOutlined fontSize="small" />,
  },
];
